import { useEffect } from 'react';

import { Carousel, Placeholder } from 'react-bootstrap';
import type { Promotion } from 'apis/DashboardApi';
import { DashboardApi } from 'apis/DashboardApi';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';
import { useApp } from 'app';

export const PromoTile = () => {

    const { highestRole, selectedPartner, userId } = useApp();

    const { formatMessage } = useIntl();

    const [state, setState] = useSuperState({
        data: null as Record<number, Promotion>,
        loading: true
    });
    const { data, loading } = state;

    const loadData = async () => {

        try {

            const promos = await DashboardApi.GetPromos(userId, highestRole.id, selectedPartner.id);
            setState({ data: promos, loading: false });

        } catch {

            setState({ loading: false });

        }

    };

    useEffect(() => {

        loadData();

    }, []);

    const items = data ? Object.values(data) : [];

    return (
        <div className={'promo-tile d-flex'}>
            {loading ?
                (
                    <Placeholder
                        animation={'wave'}
                        bg={'body-secondary'}
                        className={'rounded flex-fill'}
                        style={{ minHeight: 175 }}
                    />
                )
                :
                (
                    <Carousel className={'rounded shadow-sm'} controls={items.length > 1} indicators={items.length > 1} interval={null}>
                        {!!items?.length && items.map(promo => (
                            <Carousel.Item key={promo.Index}>
                                <a
                                    href={promo.PageURL.replace('~/', '/')}
                                    rel="noreferrer"
                                    target={promo.OpenInNewTab ? '_blank' : '_self'}
                                >
                                    <img
                                        alt={promo.Title || formatMessage({ id: 'promotion.f61521fd', defaultMessage: 'Promotion' })}
                                        className="d-block w-100"
                                        src={promo.BannerImageURL}
                                    />
                                </a>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                )
            }
        </div>
    );

};